import { nanoid } from 'nanoid';

/**
 * @deprecated will be removed in the next major release
 */
export const generateRandomId = nanoid;
